<template>
  <div class="equip-accordion__row">
    <button
      class="equip-accordion__header"
      type="button"
      @click="toggleGroup"
      :aria-expanded="isGroupOpen.toString()"
    >
      <span class="equip-accordion__title">{{ group.name || 'Egyéb' }}</span>
      <i :class="isGroupOpen ? 'fas fa-minus' : 'fas fa-plus'" class="equip-accordion__icon"></i>
    </button>
    <transition name="collapse-fade">
      <div v-show="isGroupOpen" class="equip-accordion__body">
        <template v-for="item in filtered(group.items)">
          <extra-equipmen-with-price
            v-if="item.ADDFlag === 2"
            :key="item.ADDID"
            :item="item"
          />
          <extra-equipment-in-package
            v-else
            :key="`package_${item.ADDID}`"
            :item="item"
          />
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import ExtraEquipmenWithPrice from './ExtraEquipmenWithPrice';
  import ExtraEquipmentInPackage from './ExtraEquipmentInPackage';
  import { namespace } from 'vuex-class';

  const configuratorModule = namespace('configurator');

  @Component({
    components: {ExtraEquipmentInPackage, ExtraEquipmenWithPrice}
  })
  export default class ExtraEquipmentGroup extends Vue {
    @Prop(Object) group;

    @configuratorModule.State('stockMode') stockMode;
    @configuratorModule.State('selectedEquipments') selectedEquipments;

    isGroupOpen = false;

    toggleGroup() {
      this.isGroupOpen = !this.isGroupOpen;
    }

    filtered(items) {
      if (!this.stockMode) {
        return items;
      }

      return items.filter(item => this.selectedEquipments.includes(item.ADDID))
    }
  }
</script>

<style scoped>
.equip-accordion__row {
  border-bottom: 1px solid #e5e7eb;
}
.equip-accordion__row:last-child {
  border-bottom: none;
}
.equip-accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease;
}
.equip-accordion__header:hover {
  background-color: #f9fafb;
}
.equip-accordion__title {
  font-weight: 700;
  color: #0b3b6b;
  font-size: 0.95rem;
}
.equip-accordion__icon {
  color: #0b3b6b;
  font-size: 0.85rem;
  flex-shrink: 0;
}
.equip-accordion__body {
  padding: 4px 16px 16px;
}
.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.3s, max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
  max-height: 0;
}
.collapse-fade-enter-to, .collapse-fade-leave {
  opacity: 1;
  max-height: 1000px;
}
</style>
